import { useMutation } from "@tanstack/react-query";
import { axiosInterceptor } from "..";

const exportStudents = async (orgId: string): Promise<Blob> => {
  const { data } = await axiosInterceptor.get(
    `/progression-b2b/${orgId}/students/export`,
    {
      headers: {
        source: "web",
      },
      responseType: "blob",
    }
  );
  return data;
};

const useExportStudents = () => {
  return useMutation({
    mutationFn: (orgId: string) => exportStudents(orgId),
  });
};

export default useExportStudents;
